var BASE_URL = "http://sensortecnologia.com/sensor-api/public";
// var BASE_URL = "http://localhost:8888";
export default {
    BASE_URL: BASE_URL
}